/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StackSpecificFrame
 */
export interface StackSpecificFrame {
    /**
     * 
     * @type {number}
     * @memberof StackSpecificFrame
     */
    index: number;
    /**
     * 
     * @type {number}
     * @memberof StackSpecificFrame
     */
    relativeLine?: number;
}

/**
 * Check if a given object implements the StackSpecificFrame interface.
 */
export function instanceOfStackSpecificFrame(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "index" in value;

    return isInstance;
}

export function StackSpecificFrameFromJSON(json: any): StackSpecificFrame {
    return StackSpecificFrameFromJSONTyped(json, false);
}

export function StackSpecificFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): StackSpecificFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'index': json['index'],
        'relativeLine': !exists(json, 'relative_line') ? undefined : json['relative_line'],
    };
}

export function StackSpecificFrameToJSON(value?: StackSpecificFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'index': value.index,
        'relative_line': value.relativeLine,
    };
}

